import CurrencyIcon from "@/components/icons/CurrencyIcon";
import { useRouter } from "next/router";
// import Installments from "./Installments";

const PriceV2 = ({
  discount,
  originalPrice,
  specialPrice,
  fromInfo = true,
  // fromProductCard = false,
  // priceMonthly,
}) => {
  const { locale } = useRouter();
  return (
    <div
      dir={locale == "en" ? "ltr" : "rtl"}
      className={`flex justify-between items-center w-full ${
        !fromInfo && "my-1"
      }`}
    >
      <div className="flex flex-wrap gap-1 justify-between items-center text-xs">
        {discount > 0 && (
          <div
            className={`${
              fromInfo ? "text-[12px]" : "text-[10px]"
            } line-through flex items-center gap-1 font-bold text-[#B3B3B3]`}
          >
            <span>
              {fromInfo
                ? Math.round(originalPrice)?.toLocaleString()
                : originalPrice}
            </span>
            <CurrencyIcon className="size-3" />
          </div>
        )}
        <div className={`flex items-center gap-1 font-semibold text-lg`}>
          <span>
            {fromInfo
              ? Math.round(specialPrice || originalPrice)?.toLocaleString()
              : specialPrice || originalPrice}
          </span>
          <CurrencyIcon className="size-4" />
        </div>
      </div>

      {/* {!fromInfo && (
        <Installments
          {...{
            fromInfo,
            fromProductCard,
            specialPrice,
            originalPrice,
            priceMonthly,
            locale,
          }}
        />
      )} */}
    </div>
  );
};

export default PriceV2;
